



































































































































































import { Vue, Component } from 'vue-property-decorator';
import { mdbAlert, mdbTooltip, mdbBtn, mdbRow, mdbCol, mdbInput, mdbSelect, mdbIcon, mdbCard, mdbCardImage, mdbView, mdbMask, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText } from '@folky-tools/mdbvue';
import {
    usersService,
    businessFrontPagesService,
    notificationsService,
    getBusinessFrontPageHighlightService,
    newBusinessFrontPageHighlightService,
    NewBusinessFrontPageHighlightServiceInputDto,
    updateBusinessFrontPageHighlightService,
    UpdateBusinessFrontPageHighlightServiceInputDto
} from '@/services';
import { referencesClassificationService } from '@/services/references-classification.service';
import { BusinessFrontPage } from '@/models/businesses/business-front-page';
import { BusinessFrontPageHighlightType } from '@/models/businesses/business-front-page-highlight';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { Category } from '@/models/references-classification/category';

@Component({
    components: {
        mdbAlert,
        mdbTooltip,
        mdbBtn,
        mdbRow,
        mdbCol,
        mdbInput,
        mdbSelect,
        mdbIcon,
        mdbCard,
        mdbCardImage,
        mdbView,
        mdbMask,
        mdbCardHeader,
        mdbCardBody,
        mdbCardTitle,
        mdbCardText,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        FileUpload: () => import('@/components/shared/FileUpload.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class EditBusinessCustomHighlightsView extends Vue {
    private businessFrontPage: BusinessFrontPage = new BusinessFrontPage();
    private linkTypes: any[] = [];
    private categories: Category[] = new Array<Category>();
    private characteristics: any[] = new Array();
    private isLinkTypeSelected: boolean = false;
    private isCategorySelected: boolean = false;
    private isCharacteristicSelected: boolean = false;
    private isVisibleCategorySelection: boolean = false;
    private isVisibleCharacteristicSelection: boolean = false;
    private isVisibleAllReferencesSelection: boolean = false;
    private isVisibleDiscountsSelection: boolean = false;
    private isVisibleContactSelection: boolean = false;
    private isSelectedCategoryMissing: boolean = false;
    private isSelectedCharacteristicMissing: boolean = false;
    private isSavingData: boolean = false;

    private highlightUniqueIdentifier: string = '';
    private highlightTitle: string | null = '';
    private highlightValue: number | null = null;
    private highlightImage: File | null = null;
    private highlightImageUrl: string = '';
    private highlightType: BusinessFrontPageHighlightType = BusinessFrontPageHighlightType.AllReferences;

    private showEditImage: boolean = false;
    private changingImage: boolean = false;

    private async created(): Promise<void> {
        const allHtmlEntities = require('html-entities').AllHtmlEntities;

        const businessFrontPage = await businessFrontPagesService.getBusinessFrontPage(+this.$route.params.id);

        if (businessFrontPage) {
            this.businessFrontPage = businessFrontPage;
        }

        if (this.$route.params.customHighlightId) {
            const existingHighlight = await getBusinessFrontPageHighlightService.execute(+this.$route.params.id, this.$route.params.customHighlightId);

            this.highlightUniqueIdentifier = existingHighlight.uniqueIdentifier;
            this.highlightType = existingHighlight.type;
            this.highlightValue = existingHighlight.value;
            this.highlightImageUrl = existingHighlight.imageUrl ? existingHighlight.imageUrl : '';
            this.highlightTitle = existingHighlight.title;
        }

        this.categories = (await referencesClassificationService.getCategories(this.businessFrontPage.businessId)).map(c => {
            const category = c.clone();

            let space = '';
            for (let i = 0; i < category.level; i++) {
                space += '     ';
            }
            category.name = `${space}${category.name}`;

            const selected: boolean = this.highlightType === BusinessFrontPageHighlightType.Category && category.id === this.highlightValue;

            category.selected = selected;

            if (selected) {
                this.isCategorySelected = true;
                this.isCharacteristicSelected = false;
                this.isSelectedCategoryMissing = false;
            }

            return category;
        });

        const characteristics = await referencesClassificationService.getCharacteristics(this.businessFrontPage.businessId);
        if (characteristics && characteristics.length > 0) {
            // this.characteristics.push({ value: 0, disabled: true, optgroup: true });

            let i = -1;
            characteristics
                .filter(c => c.values && c.values.length > 0)
                .forEach(c => {
                    this.characteristics.push({
                        value: --i,
                        text: c.name,
                        selected: false,
                        disabled: true
                    });
                    c.values.forEach(v => {
                        const selected: boolean = this.highlightType === BusinessFrontPageHighlightType.Characteristic && v.id === this.highlightValue;

                        this.characteristics.push({
                            value: v.id,
                            text: `    ${v.name}`,
                            selected,
                            disabled: false
                        });

                        if (selected) {
                            this.isCharacteristicSelected = true;
                            this.isCategorySelected = false;
                            this.isSelectedCharacteristicMissing = false;
                        }
                    });
                });
        }

        this.linkTypes.push({
            text: this.$t('views.businesses.editBusinessCustomHighlightsView.highlightLinkDestination.linkTypeSelector.options.category'),
            value: BusinessFrontPageHighlightType.Category,
            selected: this.highlightType === BusinessFrontPageHighlightType.Category
        });
        this.linkTypes.push({
            text: this.$t('views.businesses.editBusinessCustomHighlightsView.highlightLinkDestination.linkTypeSelector.options.characteristic'),
            value: BusinessFrontPageHighlightType.Characteristic,
            selected: this.highlightType === BusinessFrontPageHighlightType.Characteristic
        });
        this.linkTypes.push({
            text: this.$t('views.businesses.editBusinessCustomHighlightsView.highlightLinkDestination.linkTypeSelector.options.other'),
            value: null,
            disabled: true,
            optgroup: true
        });
        this.linkTypes.push({
            text: `${new allHtmlEntities().decode('&nbsp;&nbsp;&nbsp;&nbsp;')}${this.$t('views.businesses.editBusinessCustomHighlightsView.highlightLinkDestination.linkTypeSelector.options.allCategories')}`,
            value: BusinessFrontPageHighlightType.AllReferences,
            selected: this.highlightType === BusinessFrontPageHighlightType.AllReferences
        });
        this.linkTypes.push({
            text: `${new allHtmlEntities().decode('&nbsp;&nbsp;&nbsp;&nbsp;')}${this.$t('views.businesses.editBusinessCustomHighlightsView.highlightLinkDestination.linkTypeSelector.options.offers')}`,
            value: BusinessFrontPageHighlightType.DiscountedReferences,
            selected: this.highlightType === BusinessFrontPageHighlightType.DiscountedReferences
        });
        this.linkTypes.push({
            text: `${new allHtmlEntities().decode('&nbsp;&nbsp;&nbsp;&nbsp;')}${this.$t('views.businesses.editBusinessCustomHighlightsView.highlightLinkDestination.linkTypeSelector.options.contact')}`,
            value: BusinessFrontPageHighlightType.Contact,
            selected: this.highlightType === BusinessFrontPageHighlightType.Contact
        });
    }

    private async mounted(): Promise<void> {
        if (this.$route.params.customHighlightId) {
            this.$root.$emit('change-active-page', 'views.businesses.editBusinessCustomHighlightsView.editTitle', this.$route.query.businessName ? this.$route.query.businessName : '...');
        } else {
            this.$root.$emit('change-active-page', 'views.businesses.editBusinessCustomHighlightsView.newTitle', this.$route.query.businessName ? this.$route.query.businessName : '...');
        }
    }

    private async onChangeLinkType(value: BusinessFrontPageHighlightType, text: string): Promise<void> {
        switch (value) {
            case BusinessFrontPageHighlightType.Category:
                this.resetCharacteristicSelection();
                this.isVisibleCategorySelection = true;
                this.isVisibleCharacteristicSelection = false;
                this.isVisibleAllReferencesSelection = false;
                this.isVisibleDiscountsSelection = false;
                this.isVisibleContactSelection = false;
                this.isLinkTypeSelected = true;
                break;

            case BusinessFrontPageHighlightType.Characteristic:
                this.resetCategorySelection();
                this.isVisibleCategorySelection = false;
                this.isVisibleCharacteristicSelection = true;
                this.isVisibleAllReferencesSelection = false;
                this.isVisibleDiscountsSelection = false;
                this.isVisibleContactSelection = false;
                this.isLinkTypeSelected = true;
                break;

            case BusinessFrontPageHighlightType.AllReferences:
                this.resetCategorySelection();
                this.resetCharacteristicSelection();
                this.highlightValue = null;
                this.isVisibleCategorySelection = false;
                this.isVisibleCharacteristicSelection = false;
                this.isVisibleAllReferencesSelection = true;
                this.isVisibleDiscountsSelection = false;
                this.isVisibleContactSelection = false;
                this.isLinkTypeSelected = true;
                break;

            case BusinessFrontPageHighlightType.DiscountedReferences:
                this.resetCategorySelection();
                this.resetCharacteristicSelection();
                this.highlightValue = null;
                this.isVisibleCategorySelection = false;
                this.isVisibleCharacteristicSelection = false;
                this.isVisibleAllReferencesSelection = false;
                this.isVisibleDiscountsSelection = true;
                this.isVisibleContactSelection = false;
                this.isLinkTypeSelected = true;
                break;

            case BusinessFrontPageHighlightType.Contact:
                this.resetCategorySelection();
                this.resetCharacteristicSelection();
                this.highlightValue = null;
                this.isVisibleCategorySelection = false;
                this.isVisibleCharacteristicSelection = false;
                this.isVisibleAllReferencesSelection = false;
                this.isVisibleDiscountsSelection = false;
                this.isVisibleContactSelection = true;
                this.isLinkTypeSelected = true;
                break;

            default:
                this.resetCategorySelection();
                this.resetCharacteristicSelection();
                this.highlightValue = null;
                this.isVisibleCategorySelection = false;
                this.isVisibleCharacteristicSelection = false;
                this.isVisibleAllReferencesSelection = false;
                this.isVisibleDiscountsSelection = false;
                this.isVisibleContactSelection = false;
                this.isLinkTypeSelected = false;
                break;
        }
        this.highlightType = value;
    }

    private resetCategorySelection(): void {
        const selectedCategory = this.categories.find(c => c.selected);
        if (selectedCategory !== undefined) {
            selectedCategory.selected = false;
        }
    }

    private resetCharacteristicSelection(): void {
        const selectedCharacteristic = this.characteristics.find(c => c.selected);
        if (selectedCharacteristic !== undefined) {
            selectedCharacteristic.selected = false;
        }
    }

    private onChangeCategory(categoryId: number | null, text: string): void {
        if (categoryId) {
            this.isCategorySelected = true;
            this.isCharacteristicSelected = false;
            this.isSelectedCategoryMissing = false;
            this.highlightValue = categoryId;
        }
    }

    private onChangeCharacteristicValue(characteristicValueId: number | null, text: string): void {
        if (characteristicValueId) {
            this.isCharacteristicSelected = true;
            this.isCategorySelected = false;
            this.isSelectedCharacteristicMissing = false;
            this.highlightValue = characteristicValueId;
        }
    }

    private editImage() {
        this.showEditImage = true;
    }

    private async changeImage(): Promise<void> {
        this.changingImage = true;
        try {
            const image: File = (this.$refs.editImage as any).getFinalImageFile();
            if (image) {
                const existingHighlight = this.$route.params.customHighlightId ? await getBusinessFrontPageHighlightService.execute(+this.$route.params.id, this.$route.params.customHighlightId) : null;
                const highlightImageUrl = existingHighlight && existingHighlight.imageUrl ? existingHighlight.imageUrl : '';
                if (this.highlightImageUrl !== highlightImageUrl) {
                    this.highlightImage = image;
                }
            }
            this.showEditImage = false;
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.changingImage = false;
        }
    }

    private async closeEditImage(): Promise<void> {
        const existingHighlight = this.$route.params.customHighlightId ? await getBusinessFrontPageHighlightService.execute(+this.$route.params.id, this.$route.params.customHighlightId) : null;
        if (this.highlightImage === null && existingHighlight && existingHighlight.imageUrl) {
            this.highlightImageUrl = existingHighlight.imageUrl;
        }
        this.showEditImage = false;
    }

    private removeImage() {
        this.highlightImageUrl = '';
        this.highlightImage = null;
    }

    private hasErrors(): boolean {
        if (this.isVisibleCategorySelection && !this.isCategorySelected) {
            this.isSelectedCategoryMissing = true;
            return true;
        }
        if (this.isVisibleCharacteristicSelection && !this.isCharacteristicSelected) {
            this.isSelectedCharacteristicMissing = true;
            return true;
        }
        return false;
    }

    private async saveChanges(): Promise<void> {
        this.isSavingData = true;

        if (this.hasErrors()) {
            this.isSavingData = false;
            return;
        }

        try {
            if (this.$route.params.customHighlightId) {
                const highlight: UpdateBusinessFrontPageHighlightServiceInputDto = new UpdateBusinessFrontPageHighlightServiceInputDto(
                    this.highlightUniqueIdentifier,
                    this.highlightTitle,
                    this.highlightValue,
                    this.highlightImageUrl,
                    this.highlightImage,
                    this.highlightType
                );
                if (await updateBusinessFrontPageHighlightService.execute(+this.$route.params.id, highlight)) {
                    notificationsService.showToastSuccessNotification('views.businesses.editBusinessCustomHighlightsView.notifications.updateBusinessFrontPageHighlight.success');
                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Businesses,
                            scope: UserActionScopeType.CustomHighlights,
                            entityId: +this.$route.params.id
                        })
                    );
                    this.$router.back();
                    return;
                }
            } else {
                const highlight: NewBusinessFrontPageHighlightServiceInputDto = new NewBusinessFrontPageHighlightServiceInputDto(this.highlightTitle, this.highlightValue, this.highlightImage, this.highlightType);
                if (await newBusinessFrontPageHighlightService.execute(+this.$route.params.id, highlight)) {
                    notificationsService.showToastSuccessNotification('views.businesses.editBusinessCustomHighlightsView.notifications.newBusinessFrontPageHighlight.success');

                    this.$router.back();
                    return;
                }
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.isSavingData = false;
        }
    }
}
